import { SchemaModel } from '../../../../models/schemaModel';
import { VersionableId } from '../../../../types/versionableId';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { selectEsmeByVersionableId } from '../../../../store/esme/esmeSelector';
import { selectAllSmscByCommitId } from '../../../../store/smsc/smscSelector';
import EsmeApi from '../../../../api/esmeApi';
import { fetchSchemaByName } from '../../../../store/schemas/schemasActions';
import EsmeForm from '../../components/esme/EsmeForm';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';
import { EsmeObject } from '../../../../models/esmeModel';

type Props = {
  readonly schema: SchemaModel;
  readonly esmeId: VersionableId;
  readonly hideEsmeForm: () => void;
};

const EsmeEditFormContainer = (props: Props) => {
  const { schema, esmeId, hideEsmeForm } = props;

  const dispatch = useAppDispatch();
  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();

  const esme = useAppSelector(state => selectEsmeByVersionableId(state, esmeId));
  const smscIdList = useAppSelector(state => selectAllSmscByCommitId(state, esmeId.commitId))
    .map(smsc => smsc.object)
    .map(smscObject => smscObject.smscId);

  const initialValues = {
    user: esme?.object.user,
    moRoutes: esme?.object.moRoutes,
    mtRoutes: esme?.object.mtRoutes,
  };

  const handleEditEsme = (esme: EsmeObject) => {
    const schemaName = schema.name;
    const esmeName = esmeId.resourceName;

    EsmeApi.updateEsme(schemaName, esmeName, esme)
      .then(() => {
        dispatch(fetchSchemaByName(schemaName));
        hideEsmeForm();
      })
      .catch(addError);
  };

  return (
    <>
      { hasErrors && (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      )}

      <EsmeForm
        title='Edit esme'
        esmeId={esmeId}
        smscIdList={smscIdList}
        initialValues={initialValues}
        onSubmit={handleEditEsme}
        onCancel={hideEsmeForm}
        readOnly={false}
      />
    </>
  );
};

export default EsmeEditFormContainer;
